var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scale",attrs:{"id":"app"}},[_c('tabs',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTabs),expression:"showTabs"}],attrs:{"tabIndex":_vm.tabIndex}}),_c('router-view'),_c('bottom',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBottom),expression:"showBottom"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }